import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { sanitizeHtml } from '../utils/sanitizeHtml';

const API = process.env.REACT_APP_BACKEND_URL;

export default function LegalDocument() {
  const navigate = useNavigate();
  const { slug, lang } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/api/legal/${slug}`);
        setDoc(r.data);
      } catch (e) {
        setError(e.response?.status === 404 ? 'Документ не найден' : 'Ошибка загрузки');
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-3">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="legal-back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" /> Назад
          </Button>
          <h1 className="font-semibold text-lg">{doc?.title || 'Документ'}</h1>
          {doc?.version && (
            <span className="ml-auto text-xs text-gray-400">v{doc.version}</span>
          )}
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-4 py-6">
        {loading && (
          <div className="flex justify-center py-20">
            <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
          </div>
        )}
        {error && (
          <div className="bg-red-50 text-red-700 p-4 rounded-lg">{error}</div>
        )}
        {doc && (
          <article
            className="bg-white rounded-xl shadow-sm p-6 md:p-8 prose prose-sm md:prose max-w-none"
            data-testid="legal-document-content"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(doc.content_html) }}
          />
        )}
      </div>
    </div>
  );
}
